exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex_752a4c2{display:flex;width:550px;justify-content:space-between;align-items:center}.tableW_eab4a6e{width:700px;padding-left:60px;margin:10px 0 20px}", ""]);

// exports
exports.locals = {
	"flex": "flex_752a4c2",
	"tableW": "tableW_eab4a6e"
};